import React from 'react';
import { VideoLandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingMp4ToWavConverterConfig } from '@/data/landingConfig/landingMp4ToWavConverterConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_Mp4ToWavConverter } from './schemaObject';

interface Props {}
const Mp4ToWavConverter: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_Mp4ToWavConverter} />
			<VideoLandingTemplate
				data={landingMp4ToWavConverterConfig}
				funnelLinkService={GenerateLandingLinkService.funnelVideoConverter()}
			/>
		</>
	);
};

export default Mp4ToWavConverter;
